import React from "react";
import { NavLink } from "react-router-dom";
export var useInformation = function () {
    return (React.createElement("div", { className: "information d-flex flex-column gap-10" },
        React.createElement("h4", { className: "mb-0 DMSansNormal_12_400 txt_blackOne1" }, "How to calculate Interest & Dividend"),
        React.createElement("ol", { className: "DMsanR_10_400 txt_primaryGrey p-0 d-flex flex-column gap-10" },
            React.createElement("li", null,
                "To calculate interest for Bonds refer to",
                " ",
                React.createElement(NavLink, { to: "https://indiabondinfo.nsdl.com", target: "_blank", className: "DMsanL_10_300 txt-hanBlue" }, "indiabondinfo.nsdl.com")),
            React.createElement("li", null, "Dividend is calculated based on the declared payout per share and number of shares held as of the record date."),
            React.createElement("li", null, "Check with the project manager for accurate interest."))));
};
